import http from './webhook/httpconfig'
import { cancelHTTPRequests } from '@/services/utils'
import { getCookie } from './cookie'
import { cookieConstant } from './constants'
import store from '../store'
import { generateHeaders } from './webhook/webhook'

export async function sendLogsToDatadog(payload = {}) {
  const conversationId = payload?.requestBody?.conversationId || getCookie(cookieConstant.SESSION.CONVERSATION_ID)
  const botRefId = payload?.requestBody?.botRefId || store.state.botRefId
  const logLevel = payload?.requestBody?.logLevel || 'info'
  payload.requestBody = {
    ...payload.requestBody,
    conversationId,
    botRefId
  }
  try {
    const result = await http.request({
      method: 'post',
      url: '/api/datadog',
      data: payload,
      params: {
        logLevel
      },
      headers: generateHeaders(),
      cancelToken: cancelHTTPRequests()
    })
    return result;
  } catch (error) {
    console.log(error.message)
  }
}
